import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { VerifyChangePasswordEmail } from './tools/VerifyChangePasswordEmail';
import { OTPEmail } from './tools/OTPEmail';
import { ChangePassword } from './tools/ChangePassword';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [stepper, setStepper] = useState(parseInt(0));

  const handleStep = (data) => {
    setStepper(parseInt(data))
  }

  return (
    <div className='h-screen w-full bg-white  gap-2 flex flex-row items-center justify-center relative'>
      {stepper === 0 && <VerifyChangePasswordEmail handleStep={handleStep} />}
      {stepper === 1 && <OTPEmail handleStep={handleStep} />}
      {stepper === 2 && <ChangePassword handleStep={handleStep} />}
    </div>
  )
}

export default ForgotPassword;
